import { render } from "./cargo-plane.vue?vue&type=template&id=47dd5c70&ts=true"
import script from "./cargo-plane.vue?vue&type=script&lang=ts"
export * from "./cargo-plane.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__